import React, { useState } from 'react';

const ScheduleModal = ({ isOpen, onClose, onSave, customer, routeOrder }) => {
  const [scheduledTime, setScheduledTime] = useState('');
  const [notes, setNotes] = useState('');

  const handleSave = () => {
    if (!scheduledTime) {
      alert('Vyberte prosím čas schůzky');
      return;
    }

    onSave({
      customerId: customer._id,
      customerName: customer.name,
      scheduledTime,
      notes,
      routeOrder
    });

    // Reset formuláře
    setScheduledTime('');
    setNotes('');
  };

  const handleClose = () => {
    setScheduledTime('');
    setNotes('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[120]">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
        <h3 className="text-lg font-bold text-gray-800 dark:text-white mb-4">
          📅 Naplánovat schůzku
        </h3>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
            <strong>Zákazník:</strong> {customer?.name}
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
            <strong>Adresa:</strong> {customer?.address}
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
            <strong>Pořadí v trase:</strong> {routeOrder}
          </p>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Čas schůzky *
          </label>
          <input
            type="datetime-local"
            value={scheduledTime}
            onChange={(e) => setScheduledTime(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            min={new Date().toISOString().slice(0, 16)}
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Poznámky
          </label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white resize-none"
            placeholder="Poznámky ke schůzce..."
          />
        </div>

        <div className="flex gap-2">
          <button
            onClick={handleSave}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-semibold transition"
          >
            💾 Uložit schůzku
          </button>
          <button
            onClick={handleClose}
            className="flex-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg font-semibold transition"
          >
            ❌ Zrušit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleModal;
